module.exports = __webpack_public_path__ + "img/newbalance.790ad9af.png";